import { Box, Typography } from '@mui/material';
import sourceIcon from './images/sourceIcon.png';
import destinationIcon from './images/destIcon.png';

export default function DataSetSection() {
  const handleDragStart = (event, kind) => {
    event.dataTransfer.setData('application/reactflow', kind);
    event.dataTransfer.setData('nodeType', kind);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2.125 }}>
      {/* Source */}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 75 }}>
        <Box
          draggable
          onDragStart={(e) => handleDragStart(e, 'Source')}
          sx={{
            width: 48,
            height: 48,
            border: '1px solid #525252',
            borderRadius: '2px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 1,
            position: 'relative',
            cursor: 'grab',
          }}
        >
          <Box
            component="img"
            src={sourceIcon}
            alt="Source"
            sx={{
              width: 34,
              height: 34,
              objectFit: 'contain'
            }}
          />
        </Box>
        <Typography
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 500,
            fontSize: '0.8125rem',
            color: '#525252',
            textAlign: 'center',
            lineHeight: 1.4
          }}
        >
          Source
        </Typography>
      </Box>

      {/* Destination */}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 75 }}>
        <Box
          draggable
          onDragStart={(e) => handleDragStart(e, 'Destination')}
          sx={{
            width: 48,
            height: 48,
            border: '1px solid #525252',
            borderRadius: '2px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 1,
            cursor: 'grab',
          }}
        >
          <Box
            component="img"
            src={destinationIcon}
            alt="Destination"
            sx={{
              width: 34,
              height: 34,
              objectFit: 'contain'
            }}
          />
        </Box>
        <Typography
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 500,
            fontSize: '0.8125rem',
            color: '#525252',
            textAlign: 'center',
            lineHeight: 1.4
          }}
        >
          Destination
        </Typography>
      </Box>
    </Box>
  );
}
